const STORAGE_KEY = 'inv_guest_count';
const DRAFT_KEY = 'inv_guest_draft';
const LIMIT = 1;

function getCount() {
  return parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
}

export function useGuestLimit() {
  const count = getCount();
  const isLimitReached = count >= LIMIT;
  const remaining = Math.max(0, LIMIT - count);

  function increment() {
    localStorage.setItem(STORAGE_KEY, String(getCount() + 1));
  }

  return { isLimitReached, remaining, increment };
}

/** Persist the guest invoice request so it can be claimed after registration. */
export function saveGuestDraft(invoice_type, data) {
  try {
    localStorage.setItem(DRAFT_KEY, JSON.stringify({ invoice_type, data }));
  } catch (e) {
    console.error('Failed to save guest draft:', e);
  }
}

/** Load a previously saved guest draft, or null if none exists. */
export function loadGuestDraft() {
  try {
    const raw = localStorage.getItem(DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Remove the guest draft from storage. */
export function clearGuestDraft() {
  localStorage.removeItem(DRAFT_KEY);
}
